import { useMemo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PRE_ACTIVATION_YES_NO_OPTIONS } from "../../../utils/constants";
import {
  PRE_ACTIVATION_FIELD_AGENCY_CREATIVE_BOTTLENECK,
  PRE_ACTIVATION_FIELD_AGENCY_USES_AD_AUTOMATION,
  PRE_ACTIVATION_HINT_AGENCY_CREATIVE_BOTTLENECK,
  PRE_ACTIVATION_HINT_AGENCY_USES_AD_AUTOMATION,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_CREATIVE_BOTTLENECK,
} from "../../../i18n/keysTranslations";
import FieldBlock from "../components/FieldBlock";
import FieldError from "../components/FieldError";
import FieldHint from "../components/FieldHint";
import FieldLabel from "../components/FieldLabel";
import IntakeTextField from "../../../components/Form/IntakeTextField";
import RadioGroup from "../components/RadioGroup";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";

const AgencyOperationsSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  const yesNoOptions = useMemo(
    () =>
      PRE_ACTIVATION_YES_NO_OPTIONS.map((option) => ({
        value: option.value,
        label: t(option.labelKey),
      })),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <FieldBlock>
        <FieldLabel
          htmlFor="creativeBottleneck"
          text={t(PRE_ACTIVATION_FIELD_AGENCY_CREATIVE_BOTTLENECK)}
          required
        />
        <FieldHint text={t(PRE_ACTIVATION_HINT_AGENCY_CREATIVE_BOTTLENECK)} />
        <IntakeTextField
          name="creativeBottleneck"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          multiline
          minRows={4}
          readOnly={readOnly}
          placeholder={t(PRE_ACTIVATION_PLACEHOLDER_AGENCY_CREATIVE_BOTTLENECK)}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="usesAdAutomation"
          text={t(PRE_ACTIVATION_FIELD_AGENCY_USES_AD_AUTOMATION)}
          required
        />
        <FieldHint text={t(PRE_ACTIVATION_HINT_AGENCY_USES_AD_AUTOMATION)} />
        <Controller
          name="usesAdAutomation"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <RadioGroup
                name="usesAdAutomation"
                options={yesNoOptions}
                selectedValue={field.value}
                onChange={field.onChange}
                readOnly={readOnly}
              />
              <FieldError message={fieldState.error?.message} />
            </>
          )}
        />
      </FieldBlock>
    </ReadOnlySectionGrid>
  );
};

export default AgencyOperationsSection;
